// extracted by css-extract-rspack-plugin
export default {"container":"_d0cc3b5d","isFirstMonthWeek":"_5f9b6a76"};